module.exports = __webpack_public_path__ + "img/gen-enrollment-success.00157b00.svg";